// @flow
import * as React from 'react'
import MainLoader from '../components/loadings/MainLoader'

type Props = {
  props?: any,
}

const LoadingPage: React.ComponentType<Props> = (props) => {
  return <MainLoader open {...props} />
}

export default LoadingPage
